/** Named product API operations — use instead of raw endpoint strings in pages. */
export const PRODUCT_OPERATIONS = {
  AUTHENTICATE: 'authenticate',
  SEND_OTP: 'sendOtp',
  VERIFY_LOGIN: 'verifyLogin',
  GENERATE_EMAIL_OTP: 'generateEmailOtp',
  RESEND_EMAIL_OTP: 'resendEmailOtp',
  VERIFY_EMAIL_OTP: 'verifyEmailOtp',
  SEND_COMPLAINT_OTP: 'sendComplaintOtp',
  RAISE_COMPLAINT: 'raiseComplaint'
}

/** Maps operation → endpoint key on ProductConfig.endpoints */
export const OPERATION_ENDPOINT_KEY = {
  [PRODUCT_OPERATIONS.AUTHENTICATE]: 'authenticate',
  [PRODUCT_OPERATIONS.SEND_OTP]: 'sendOtp',
  [PRODUCT_OPERATIONS.VERIFY_LOGIN]: 'verifyLogin',
  [PRODUCT_OPERATIONS.GENERATE_EMAIL_OTP]: 'generateEmailOtp',
  [PRODUCT_OPERATIONS.RESEND_EMAIL_OTP]: 'resendEmailOtp',
  [PRODUCT_OPERATIONS.VERIFY_EMAIL_OTP]: 'verifyEmailOtp',
  [PRODUCT_OPERATIONS.SEND_COMPLAINT_OTP]: 'sendUserEmailOtp',
  [PRODUCT_OPERATIONS.RAISE_COMPLAINT]: 'raiseComplaintTicket'
}
